import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { HeaderService } from 'src/app/_services/header.service';
import { Community, CommunityType } from '../community.model';
import { CommunityService } from '../community.service';

@Component({
  selector: 'app-detail-community',
  templateUrl: './detail-community.page.html',
  styleUrls: ['./detail-community.page.scss'],
})
export class DetailCommunityPage implements OnInit {
  community: Community;

  currentSegment: string;

  isError: boolean = false;
  errorStatus: number;

  title: string = '';
  loaded: boolean = false;

  constructor(
    public communityServ: CommunityService,
    private route: ActivatedRoute,
    private router: Router,
    private headerServ: HeaderService
  ) {}

  ngOnInit() {
    this.route.paramMap.subscribe((paramMap) => {
      // TODO sprawdzenie czy tenw warunek działa, nie potrafię wywołać wejścia w niego.
      if (!paramMap.has('id')) {
        // this.router.navigate(["../../community"], { relativeTo: this.route });
        this.router.navigateByUrl(this.getBackURL());
        return;
      }
      let communityId = Number(paramMap.get('id'));

      this.communityServ.getCommunity(communityId).subscribe({
        next: (res: Community) => {
          this.community = res;
          this.currentSegment = String(res.type);
          this.setHeaderTitle(res.type);
        },
        complete: () => {
          this.loaded = true;
        },
        error: (err) => {
          this.isError = true;
          this.errorStatus = err.status;
        },
      });
    });
  }

  getBackURL(): string {
    switch(this.community?.type) {
      case CommunityType.IntegrationTrip:
        return 'app/integration-trip';
      case CommunityType.GoodPracticesList:
        return 'app/practices-list';
      default:
        return 'app/community';
    }
  }

  setHeaderTitle(comType: CommunityType) {
    switch(comType) {
      case CommunityType.IntegrationTrip:
        this.title = 'COMMUNITY.COMMUNITY';
        break;
      case CommunityType.GoodPracticesList:
        this.title = 'COMMUNITY.GOOD_PRACTICES';
        break;
      default:
        this.title = 'COMMUNITY.COMMUNITY';
        break;
    }
    this.headerServ.setHeaderInit({
      title: this.title,
      backDefaultHref: this.getBackURL(),
    });
  }

  ionViewWillLeave() {
    this.title = 'COMMUNITY.COMMUNITY';
  }
}
